import { WORKER_BASE_URL } from './env'

const STROKE_ORDER_API_URL = WORKER_BASE_URL + '/stroke-order'

let strokeOrderData: Record<string, { strokes: string[] }> = {}
const requestPromises: Record<string, Promise<Record<string, { strokes: string[] }>>> = {}

export function getStrokeOrderStrokes(char: string): string[] {
  return strokeOrderData[char]?.strokes || []
}

export function getStrokeCount(char: string): number {
  return getStrokeOrderStrokes(char).length
}

export function hasStrokeData(char: string): boolean {
  return !!strokeOrderData[char]
}

export async function loadRemoteStrokeOrderData(chars: string): Promise<Record<string, { strokes: string[] }>> {
  const normalizedChars = normalizeChars(chars)
  if (!normalizedChars) return { ...strokeOrderData }

  const missingChars = normalizedChars
    .split('')
    .filter((char) => !strokeOrderData[char])
    .join('')

  if (!missingChars) return { ...strokeOrderData }
  if (missingChars in requestPromises) return requestPromises[missingChars]

  requestPromises[missingChars] = requestStrokeOrderData(missingChars)
    .then((data) => {
      if (!data || typeof data !== 'object') return {}
      const normalizedData = normalizeStrokeOrderData(data)
      strokeOrderData = { ...strokeOrderData, ...normalizedData }
      return { ...strokeOrderData }
    })
    .catch((err) => {
      console.warn('笔顺数据请求失败:', err)
      return {}
    })
    .finally(() => {
      delete requestPromises[missingChars]
    })

  return requestPromises[missingChars]
}

async function requestStrokeOrderData(chars: string): Promise<unknown> {
  console.info('笔顺数据请求:', chars)
  const response = await fetch(`${STROKE_ORDER_API_URL}?chars=${encodeURIComponent(chars)}`)
  if (!response.ok) {
    throw new Error('笔顺数据加载失败')
  }
  return response.json()
}

function normalizeChars(chars: string): string {
  return Array.from(new Set(String(chars || '').replace(/[^\u4e00-\u9fa5]/g, '').split(''))).join('')
}

function normalizeStrokeOrderData(data: unknown): Record<string, { strokes: string[] }> {
  if (!data || typeof data !== 'object') return {}

  const source = (data as Record<string, unknown>).data && typeof (data as Record<string, unknown>).data === 'object'
    ? (data as Record<string, unknown>).data
    : data

  const result: Record<string, { strokes: string[] }> = {}

  if (Array.isArray(source)) {
    source.forEach((item: unknown) => {
      if (!item || typeof item !== 'object') return
      const char = (item as Record<string, string>).char || (item as Record<string, string>).character || (item as Record<string, string>).hanzi
      const strokes = normalizeStrokes(item)
      if (char && strokes.length) {
        result[char] = { strokes }
      }
    })
    return result
  }

  Object.keys(source as Record<string, unknown>).forEach((char) => {
    const entry = (source as Record<string, unknown>)[char]
    const strokes = normalizeStrokes(entry)
    if (strokes.length) {
      result[char] = { strokes }
    }
  })

  return result
}

function normalizeStrokes(entry: unknown): string[] {
  if (Array.isArray(entry)) return entry as string[]
  if (entry && typeof entry === 'object') {
    if (Array.isArray((entry as Record<string, unknown>).strokes)) {
      return (entry as Record<string, string[]>).strokes
    }
    const nested = (entry as Record<string, unknown>).data
    if (nested && typeof nested === 'object' && Array.isArray((nested as Record<string, unknown>).strokes)) {
      return (nested as Record<string, string[]>).strokes
    }
  }
  return []
}
